import compileSymbols from '~/utils/compileSymbols';

var types = [
  'ADD_PRODUCT',
  'CHANGE_COLOR',
  'DELETE_PRODUCT',
  'REPLACE_PRODUCTS',
  'REPLACE_PRODUCTS_CART_MODE',
  'RESET',
  'SELECT_PRODUCT',
  'SWAP_PRODUCT',
  'UPDATE_CATEGORY_PATHS',
  'UPDATE_SIZE_OPTIONS',
  'UPDATE_HAS_INVALID_PRODUCT_IMAGES',
  'SET_ANCHOR_STYLE_AND_COLOR_ID'
];

export default compileSymbols(types, 'product');
